import DataOne from "./Shipment_Table_One";
import { useEffect, useState } from "react";
import axios from "axios";
import { getShipmentsURL } from "../../../Library/URLs";
import { generateTransactionID } from "../../../Library/Utilities";
import DataTwo from "./Shipment_Table_Two";

const ShipmentTable = () => {
  const [Result, setResult] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const GetShipmentHistory = async () => {
      setLoading(true);
      const Data = {
        user_id: localStorage.getItem("user_id"),
        user_ses_id: localStorage.getItem("session_id"),
        company_id: localStorage.getItem("company_id"),
        transaction_id: generateTransactionID(15),
        limit: "10",
        offset: "0",
      };
      await axios.post(getShipmentsURL, Data).then((response) => {
        const res = response.data.data;
        setLoading(false);
        setResult(Object.values(res));
      })
      .catch(() => {
        setLoading(false);
      });
    };

    GetShipmentHistory();
  }, []);

  return (
    <div className="Shipment_Table_Wrapper">
      <h4>All Shipments</h4>
      {Result !== "" && !loading && <DataOne data={Result} />}
      {Result === "" && !loading && <DataTwo />}
      {loading && (<div className="SpinContain" >
            <span className="spinner-border spinner-grow-md"/>
        </div>)}
    </div>
  );
};

export default ShipmentTable;
